import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs-timezone-iana-plugin";
import { normalizeProductName } from "../helpers/utils";
import { getProductLinePid } from "../helpers/getProductLinePid";
import { TIMEZONE } from "../constans";
import { summaryDirectNames } from "../helpers/directManagerDialogConversion";
import SummaryStats from "../components/SummaryStats/SummaryStats";
import OrdersTable from "../components/OrdersTable/OrdersTable";
import { Sliders } from "react-bootstrap-icons";
import { Button } from "react-bootstrap";
import HeaderControls from "../components/HeaderControls/HeaderControls";
import AddToSummaryButton from "../components/AddToSummaryButton";
import isoWeek from "dayjs/plugin/isoWeek";
import {io} from "socket.io-client";
import DeleteFromSummaryButton from "../components/DeleteFromSummaryButton";
dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(timezone);


// Імпорти без змін

const ReportsSummary = () => {
    const [ordersByPeriod, setOrdersByPeriod] = useState([]);
    const [adsByPeriod, setAdsByPeriod] = useState([]);

    const [showFilters, setShowFilters] = useState(false);
    const [orders, setOrders] = useState([]);
    const [ads, setAds] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [currency, setCurrency] = useState('UAH');
    const [usdBuyRate, setUsdBuyRate] = useState(null);
    const [usdSellRate, setUsdSellRate] = useState(null);
    const [rangeDate, setRangeDate] = useState("day");
    const [range, setRange] = useState({ startDate: new Date(), endDate: new Date() });
    const [isChecked, setIsChecked] = useState(false);
    const [selectedSources, setSelectedSources] = useState([]);
    const [selectedManagers, setSelectedManagers] = useState([]);
    const [tagFilterMode, setTagFilterMode] = useState("all");
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [summaries, setSummaries] = useState([]);
    const [liveOrders, setLiveOrders] = useState([]);
    const [liveCampaigns, setLiveCampaigns] = useState([]);

    const FILTER_PRESETS = [
        {
            label: "PR+",
            sources: [1,9,10],
            statuses: [1,3,4,5,6],
            selectedManagers: [],
            tagFilterMode: "no_both",
            rangeDate: "day",
            // fetchLiveToday: true,
            range: {
                startDate: dayjs().startOf("month").toDate(),
                endDate: dayjs().endOf("month").toDate()
            }
        },
        {
            label: "Опт",
            sources: [],
            statuses: [],
            selectedManagers: [],
            tagFilterMode: "only_opt",
            rangeDate: "day",
            range: {
                startDate: dayjs().startOf("month").toDate(),
                endDate: dayjs().endOf("month").toDate()
            }
        },
        {
            label: "Бартери",
            sources: [],
            statuses: [],
            selectedManagers: [],
            tagFilterMode: "only_barter",
            rangeDate: "day",
            range: {
                startDate: dayjs().startOf("month").toDate(),
                endDate: dayjs().endOf("month").toDate()
            }
        },
        {
            label: "Загальні",
            sources: [],
            statuses: [1,3,4,5],
            selectedManagers: [],
            tagFilterMode: "no_barter",
            rangeDate: "day",
            fetchLiveToday: true,
            range: {
                startDate: dayjs().startOf("month").toDate(),
                endDate: dayjs().endOf("month").toDate()
            }
        },
        {
            label: "ОП",
            sources: [1,2,4],
            statuses: [1,3,4,5,6],
            selectedManagers: [5,6,11],
            tagFilterMode: "no_both",
            rangeDate: "day",
            fetchLiveToday: true,
            range: {
                startDate: dayjs().startOf("month").toDate(),
                endDate: dayjs().endOf("month").toDate()
            }
        },
    ];

    const applyPreset = (preset) => {
        setSelectedSources(preset.sources || []);
        setSelectedStatuses(preset.statuses || []);
        setSelectedManagers(preset.selectedManagers || []);
        setTagFilterMode(preset.tagFilterMode || "all");
        setRangeDate(preset.rangeDate);
        setRange(preset.range);
        setShowFilters(false);

        if (preset.fetchLiveToday) {
            fetchLiveTodayData();
        }
    };

    const currentPreset = FILTER_PRESETS.find(p => p.label === "Загальні");

    const getTotalPurchased = (orders = []) => {
        return orders.reduce((sum, order) => {
            const products = order.products || [];
            return sum + products.reduce((acc, p) => acc + (p.purchased_price || 0), 0);
        }, 0);
    };


    const fetchLiveTodayData = async () => {
        try {
            const res = await fetch("/api/live-summary-today");
            const data = await res.json();
            setLiveOrders(data.orders || []);
            setLiveCampaigns(data.campaigns || []);
        } catch (e) {
            console.error("Помилка завантаження live-даних за сьогодні", e);
        }
    };

    useEffect(() => {
        const socket = io(); // за потреби підставте наявний socket
        socket.on("webhook-triggered", fetchLiveTodayData);

        return () => socket.off("webhook-triggered");
    }, []);

    useEffect(() => {
        // Когда пользователь меняет период вручную — сбрасываем live-данные
        setLiveOrders([]);
        setLiveCampaigns([]);
    }, [range]);


    useEffect(() => {
        const fetchSummary = async () => {
            setLoading(true);
            const start = dayjs(range.startDate).format("YYYY-MM-DD");
            const end = dayjs(range.endDate).format("YYYY-MM-DD");

            try {
                const res = await fetch(`/api/summary?start=${start}&end=${end}`);
                const data = await res.json();
                setSummaries(data);
            } catch (error) {
                console.error("Помилка завантаження summary:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSummary();
    }, [range]);

    useEffect(() => {
        const fetchExchangeRates = async () => {
            try {
                const response = await fetch("/api/exchange-rates");
                const data = await response.json();

                // Поиск курса покупки и продажи доллара (USD)
                const usdCurrency = data.find(currency => currency.currencyCodeA === 840); // 840 - код USD
                if (usdCurrency) {
                    setUsdBuyRate(usdCurrency.rateBuy);
                    setUsdSellRate(usdCurrency.rateSell);
                }
            } catch (error) {
                console.error("Помилка отримання даних про курс валют:", error);
            }
        };

        fetchExchangeRates();
    }, []);


    useEffect(() => {
        if (!summaries || summaries.length === 0) return;

        // Объединяем заказы
        const allOrders = summaries.flatMap(summary => summary.orders || []);

        // Преобразуем кампании в "ads", добавляя дату
        const allAds = summaries.flatMap(summary =>
            (summary.campaigns || []).map(camp => ({
                ...camp,
                date: summary.date
            }))
        );

        // Можно сразу сохранить курсы валют из последнего дня
        const lastDay = summaries[summaries.length - 1];
        if (lastDay?.usdRate?.usdBuyRate && lastDay?.usdRate?.usdSellRate) {
            setUsdBuyRate(lastDay.usdRate.usdBuyRate);
            setUsdSellRate(lastDay.usdRate.usdSellRate);
        }

        setOrders(allOrders);
        setAds(allAds);
    }, [summaries]);

    const groupedByDate = summaries.reduce((acc, summary) => {
        const date = summary.date;
        if (!acc[date]) {
            acc[date] = {
                orders: [],
                campaigns: [],
                leads: 0, // 👈
            };
        }

        acc[date].orders.push(...(summary.orders || []));
        acc[date].campaigns.push(...(summary.campaigns || []));
        acc[date].leads = summary.leads ?? 0;
        acc[date].tickets = summary.tickets ?? { instagram: 0, telegram: 0 };
        return acc;
    }, {});

    const leadsByPeriod = Object.values(groupedByDate).map(group => group.leads);
    const ticketsByPeriod = Object.values(groupedByDate).map(group => group.tickets || {});



    useEffect(() => {
        if (!summaries || summaries.length === 0) return;

        const filterCampaigns = (campaigns) => {
            return campaigns.filter(ad => {
                const name = ad.campaign_name?.toLowerCase() || "";
                const has9 = selectedSources.includes(9);
                const has1 = selectedSources.includes(1);
                const has4 = selectedSources.includes(4);
                const has10 = selectedSources.includes(10);

                if ((has9 && (has1 || has4)) || (!has1 && !has4 && !has9 && !has10)) {
                    return true;
                }

                return has9
                    ? name.includes("сайт") // ✅ проверка без регистра
                    : !name.includes("сайт");
            });
        };

        const groupedByDate = summaries.reduce((acc, summary) => {
            const date = summary.date;
            if (!acc[date]) {
                acc[date] = {
                    orders: [],
                    campaigns: [],
                };
            }

            // ✅ Добавляем заказы как есть
            acc[date].orders.push(...(summary.orders || []));

            // ✅ Сначала фильтруем кампании, затем добавляем
            const filteredCampaigns = filterCampaigns(summary.campaigns || []);
            acc[date].campaigns.push(...filteredCampaigns.map(c => ({ ...c, date })));

            return acc;
        }, {});

        const groupedOrders = Object.values(groupedByDate).map(group => group.orders);
        const groupedAds = Object.values(groupedByDate).map(group => group.campaigns);

        setOrdersByPeriod(groupedOrders);
        setAdsByPeriod(groupedAds);
    }, [summaries, selectedSources]); // 👈 добавляем selectedSources в зависимости


    // summaries.forEach(summary => {
    //     console.log(summary.date, summary.daySpend, summary.orders.length);
    // });

    const formatCurrency = (value) => {
        if (currency === 'USD') {
            return `$${(value / usdSellRate).toFixed(2)}`;
        }
        return `${value.toLocaleString()} грн.`;
    };

    const formatAdBudget = (value) => {
        if (currency === 'USD') {
            return `$${value.toFixed(2)}`;
        }
        return `${(value * usdSellRate).toFixed(0).toLocaleString()} грн.`;
    };

    const getTotalUpsales = (orders = []) => {
        return orders.reduce((total, order) => {
            if (!order.products || !Array.isArray(order.products)) return total;
            const upsalesInOrder = order.products.filter(product => product.upsale).length;
            return total + upsalesInOrder;
        }, 0);
    };

    const getRepeatSalesWithTag5 = (orders = []) => {
        return orders.filter(order =>
            order.tags?.some(tag => tag.id === 5)
        ).length;
    };

    const getSaleOrdersWithTag6 = (orders = []) => {
        return orders.filter(order =>
            order.tags?.some(tag => tag.id === 6)
        ).length;
    };

    const getTotalPayments = (orders = []) => {
        return orders.reduce((sum, order) => {
            return sum + (order.payments_total || 0);
        }, 0);
    };

    console.log("orders:", orders)
    const filteredOrders = orders.filter(order => {
        const hasBarterTag = order.tags?.some(tag => tag.id === 1);
        const hasWholesaleTag = order.tags?.some(tag => tag.id === 4);

        const matchesTagFilter = () => {
            switch (tagFilterMode) {
                case 'no_opt':
                    return !hasWholesaleTag;
                case 'no_barter':
                    return !hasBarterTag;
                case 'no_both':
                    return !hasBarterTag && !hasWholesaleTag;
                case 'only_barter':
                    return hasBarterTag;
                case 'only_opt':
                    return hasWholesaleTag;
                default:
                    return true;
            }
        };

        const matchesSourceFilter = selectedSources.length === 0 || selectedSources.includes(order.source_id);
        const matchesManagerFilter = selectedManagers.length === 0 || selectedManagers.includes(order.manager?.id);

        const statusIds = [20, 21, 39];
        const matchesStatusFilter = () => {
            if (selectedStatuses.length === 0) return true;

            // если текущая группа не выбрана — исключаем
            if (!selectedStatuses.includes(order.status_group_id)) return false;

            // если выбрана группа 6 — фильтруем по status_id
            if (order.status_group_id === 6) {
                return statusIds.includes(order.status_id);
            }

            // если группа не 6 — пропускаем
            return true;
        };

        return (
            matchesTagFilter() &&
            matchesSourceFilter &&
            matchesManagerFilter &&
            matchesStatusFilter()
        );
    });


    const combinedData = filteredOrders.flatMap(order =>
        order.products.map(product => {
            const pid = getProductLinePid(product);
            return {
                pid,
                name: normalizeProductName(product.name),
                quantity: product.quantity || 0,
                purchased_price: product.purchased_price || 0,
                spend: 0,
                impressions: 0,
                clicks: 0,
            };
        })
    ).reduce((acc, item) => {
        const existing = acc.find((el) => el.pid === item.pid);
        if (existing) {
            existing.quantity += item.quantity;
            existing.purchased_price += item.purchased_price;
        } else {
            acc.push({ ...item });
        }
        return acc;
    }, []);

    const summaryByProductArr = [...combinedData].sort((a, b) => b.quantity - a.quantity);
    const productBreakdownColumns = summaryByProductArr.map((p) => ({
        pid: p.pid != null && Number.isFinite(Number(p.pid)) ? Number(p.pid) : null,
        name: p.name ?? "",
    }));

    const handleCheckboxChange = () => {
        setIsChecked(prev => !prev);
    };



    const getLocaleDate = (utcDate) => {
        const localeDate = new Date(utcDate);
        return localeDate.toLocaleDateString("ru-RU").replace(/\./g, "-");
    };

    const getOrdersByRange = (arr, range) => {
        return arr.reduce((groups, order) => {
            const date = dayjs(order.created_at).tz(TIMEZONE);

            let start, end;

            switch (range) {
                case "day":
                    start = date.startOf("day");
                    end = date.endOf("day");
                    break;
                case "week":
                    start = date.startOf("isoWeek");
                    end = start.add(6, "day");
                    break;
                case "2weeks":
                    start = date.startOf("isoWeek");
                    const weekNum = Math.floor(start.isoWeek() / 2);
                    start = start.isoWeek(weekNum * 2);
                    end = start.add(13, "day");
                    break;
                case "month":
                    start = date.startOf("month");
                    end = date.endOf("month");
                    break;
                case "year":
                    start = date.startOf("year");
                    end = date.endOf("year");
                    break;
                default:
                    return groups;
            }

            const key = `${start.format("YYYY-MM-DD")}_${end.format("YYYY-MM-DD")}`;

            const existingGroup = groups.find(g => g.key === key);
            if (existingGroup) {
                existingGroup.orders.push(order);
            } else {
                groups.push({
                    key,
                    start,
                    end,
                    orders: [order]
                });
            }

            return groups;
        }, []).map(g => g.orders);
    };

    const filteredLeadsByPeriod = leadsByPeriod.slice(0, getOrdersByRange(filteredOrders, rangeDate).length);

    const getTotalLeads = () => {
        return filteredLeadsByPeriod.reduce((sum, day) => {
            if (selectedSources.length === 1) {
                if (selectedSources.includes(1) || selectedSources.includes(4)) {
                    return sum + (day.instagram || 0);
                }
                if (selectedSources.includes(2)) {
                    return sum + (day.telegram || 0);
                }
                return sum;
            }
            return sum + (day.instagram || 0) + (day.telegram || 0);
        }, 0);
    };

    const filteredTicketsByPeriod = ticketsByPeriod?.slice(0, getOrdersByRange(filteredOrders, rangeDate).length) || [];

    const getTotalTickets = () => {
        return filteredTicketsByPeriod.reduce((sum, day) => {
            if (selectedSources.length === 1) {
                if (selectedSources.includes(1) || selectedSources.includes(4)) {
                    return sum + (day.instagram || 0);
                }
                if (selectedSources.includes(2)) {
                    return sum + (day.telegram || 0);
                }
                return sum;
            }
            return sum + (day.instagram || 0) + (day.telegram || 0);
        }, 0);
    };

    const ordersByPeriodExtended = [...getOrdersByRange(filteredOrders, rangeDate)];
    const adsByPeriodExtended = [...adsByPeriod];

    if (liveOrders.length > 0 || liveCampaigns.length > 0) {
        ordersByPeriodExtended.push(liveOrders);
        adsByPeriodExtended.push(liveCampaigns);
    }

    const directManagerByDate = {};
    for (const s of summaries || []) {
        if (s?.date) directManagerByDate[s.date] = summaryDirectNames(s).join(" + ");
    }
    const directManagersByPeriod = ordersByPeriodExtended.map((periodOrders) => {
        if (!periodOrders?.length) return "";
        const dayKey = dayjs(periodOrders[0].created_at).tz(TIMEZONE).format("YYYY-MM-DD");
        return directManagerByDate[dayKey] || "";
    });

    useEffect(() => {
        const defaultPreset = FILTER_PRESETS.find(p => p.label === "Загальні");
        if (defaultPreset) {
            applyPreset(defaultPreset);
        }
    }, []);


    return (
        <div className="d-flex layout-wrapper" style={{ height: '100%', minHeight: '100vh', transition: 'all 0.3s ease-in-out' }}>
            {showFilters && (
                <div style={{ width: 280, flexShrink: 0 }} className="bg-light border-end h-100 overflow-auto">
                    <HeaderControls
                        usdBuyRate={usdBuyRate}
                        usdSellRate={usdSellRate}
                        currency={currency}
                        setCurrency={setCurrency}
                        range={range}
                        setRange={setRange}
                        isLoading={isLoading}
                        onRangeSelected={setRangeDate}
                        handleCheckboxChange={handleCheckboxChange}
                        isChecked={isChecked}
                        selectedManagers={selectedManagers}
                        setSelectedManagers={setSelectedManagers}
                        tagFilterMode={tagFilterMode}
                        setTagFilterMode={setTagFilterMode}
                        selectedSources={selectedSources}
                        toggleSource={(ids) =>
                            setSelectedSources(prev =>
                                prev.some(src => ids.includes(src))
                                    ? prev.filter(src => !ids.includes(src))
                                    : [...prev, ...ids]
                            )
                        }
                        toggleStatus={(id) =>
                            setSelectedStatuses(prev =>
                                prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]
                            )
                        }
                        selectedStatuses={selectedStatuses}
                    />
                </div>
            )}

            {/* Основна частина */}
            <div className="main-content flex-grow-1" style={{ transition: 'all 0.3s ease-in-out', height: "100%", minHeight: "100%" }}>
                <div className="p-3">
                    <Button
                        variant="dark"
                        className="text-white border border-0 rounded-3 px-4 py-2"
                        onClick={() => setShowFilters(prev => !prev)}
                    >
                        <Sliders className="me-2" size={18} /> Налаштування
                    </Button>
                    <AddToSummaryButton range={range} />
                    <DeleteFromSummaryButton range={range} />
                    <div className="d-flex flex-wrap gap-2 p-3">
                        {FILTER_PRESETS.map((preset, index) => (
                            <Button
                                key={index}
                                variant="outline-primary"
                                className="rounded-3 px-4 py-2"
                                onClick={() => applyPreset(preset)}
                            >
                                {preset.label}
                            </Button>
                        ))}
                    </div>
                </div>
                <div className="p-3">
                    <div style={{ overflowX: 'auto', width: '100%' }}>
                    <OrdersTable
                        visibleColumns={currentPreset?.columns || {}}
                        getTotalPurchased={getTotalPurchased}
                        productBreakdownColumns={productBreakdownColumns}
                        combinedData={combinedData}
                        selectedSources={selectedSources}
                        // adsByPeriod={getAdsByRangeFromFiltered(filteredAds, ordersByPeriod, rangeDate)}
                        ordersByPeriod={ordersByPeriodExtended}
                        adsByPeriod={adsByPeriodExtended}
                        getTotalLeads={getTotalLeads}
                        formatCurrency={formatCurrency}
                        formatAdBudget={formatAdBudget}
                        getTotalPayments={getTotalPayments}
                        getTotalUpsales={getTotalUpsales}
                        getRepeatSalesWithTag5={getRepeatSalesWithTag5}
                        getSaleOrdersWithTag6={getSaleOrdersWithTag6}
                        summaries={summaries}
                        leadsByPeriod={leadsByPeriod}
                        rangeDate={rangeDate}
                        ticketsByPeriod={ticketsByPeriod}
                        getTotalTickets={getTotalTickets}
                        directManagersByPeriod={directManagersByPeriod}
                    />
                </div>
                </div>
            </div>
        </div>
    );
};

export default ReportsSummary;

